import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=a8a56984&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a8a56984')) {
      api.createRecord('a8a56984', component.options)
    } else {
      api.reload('a8a56984', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=a8a56984&", function () {
      api.rerender('a8a56984', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2gC2z502njizR/JS/comp/openstreetmap.vue"
export default component.exports